'use strict';

(function () {
  'use strict';

  angular.module('msActivities').component('activityQuiz', {
    templateUrl: 'activities/templates/activity-quiz.html',
    controller: ActivityQuiz,
    controllerAs: 'vm',
    bindings: {
      quiz: '<',
      quizLabel: '<',
      close: '&',
      disableReadout: '<'
    }
  });
  ActivityQuiz.$inject = ['$log', '$scope', 'userSvc', 'focus'];

  function ActivityQuiz($log, $scope, userSvc, focus) {
    var vm = this;
    vm.$onChanges = function () {
      $log.debug("ActivityQuiz $onChanges");
      if (!vm.quiz) {
        return;
      }
      vm.questionNbr = 1;
      vm.questionCnt = vm.quiz.widgets ? vm.quiz.widgets.length : 0;
      //keep track of whether we are on last screen, taking question readouts into account
      vm.isAtEnd = false;
      vm.quizCompleted = false;
    };

    vm.nextClick = _nextClick;
    vm.previousClick = _previousClick;

    vm.closeClick = function () {
      if (vm.showReadoutSection() && !_.isEmpty(vm.userPreference)) {
        $log.debug('saving tagPreferences');
        userSvc.getUser().then(function (user) {
          if (user) {
            userSvc.saveTagPreferences(vm.userPreference).then(function () {
              _close();
            });
          } else {
            _close();
          }
        });
      } else {
        _close();
      }
    };

    $scope.$watch('vm.quiz.widgets[vm.questionCnt-1]', function (newValue) {
      if (vm.questionNbr === vm.questionCnt && !_.isEmpty(newValue.response)) {
        vm.quizCompleted = true;
      }
    }, true);

    ///////////////////
    function _close() {
      if (_.isFunction(vm.close)) {
        vm.close({ score: vm.score });
      }
    }

    function _nextClick() {

      focus.byClassName('.status', 100);

      //we are atEnd either on last question or readout of last question
      if (showQuestionReadout()) {
        //need to show readout before we move to next step
        vm.isAtEnd = vm.questionNbr === vm.questionCnt;
        return;
      }

      if (vm.questionNbr < vm.questionCnt) {
        vm.questionNbr = vm.questionNbr + 1;
        if (vm.questionNbr === vm.questionCnt && !hasQuestionReadout(vm.quiz.widgets[vm.questionNbr - 1])) {
          vm.isAtEnd = true;
        }
      } else if (vm.quiz.type === 'NO_SCORE_QUIZ') {
        vm.closeClick();
      } else {
        displayQuizResult();
      }
    }

    function _previousClick() {
      focus.byClassName('.status', 100);
      if (vm.questionNbr > 1) {
        if (vm.readout) {
          //hide readout so it re-displays question
          delete vm.readout;
        } else {
          vm.questionNbr = vm.questionNbr - 1;
        }
      }
    }

    /** Helper functions **/
    function showQuestionReadout() {
      if (vm.readout) {
        //readout already shown, clear it out
        delete vm.readout;
        return false;
      }

      var question = vm.quiz.widgets[vm.questionNbr - 1];

      if (question.type === 'quiz/quiz_check_boxes') {
        return false;
      }

      var readout = 'choice_' + question.response + '_readout';
      if (question.properties.hasOwnProperty(readout) && !_.isEmpty(question.properties[readout])) {
        vm.readout = question.properties[readout];
        vm.readoutPosition = question.position;
        $log.debug('set readoutPosition:', vm.readoutPosition);
        return true;
      } else {
        delete vm.readout;
      }

      return false;
    }

    vm.showReadoutSection = function () {
      return !vm.disableReadout && (vm.simpleScore !== undefined || vm.weightedScore !== undefined);
    };

    function displayQuizResult() {
      //calculate total score
      var isWeightedScore = vm.quiz.type === 'WEIGHTED_SCORE_QUIZ';
      var score = 0;

      vm.quiz.widgets.forEach(function (question) {
        if (question.type === 'quiz/quiz_check_boxes') {
          score = score + getCheckboxAnswerScore(question, isWeightedScore);
        } else {
          score = score + getSingleAnswerScore(question, isWeightedScore);
        }
      });

      //set display text for user
      if (isWeightedScore) {
        vm.weightedScore = score;
      } else {
        vm.simpleScore = score;
      }
      vm.score = score;
      if (vm.disableReadout) {
        vm.closeClick();
      } else {
        setReadout(score);
      }
    }

    function setReadout(score) {
      //find first readout where score falls within min/max
      for (var y = 0; y < vm.quiz.thresholds.length; y++) {
        if (score >= vm.quiz.thresholds[y].thresholdMin && score <= vm.quiz.thresholds[y].thresholdMax) {
          vm.readoutTitle = vm.quiz.thresholds[y].title || undefined;
          vm.readout = vm.quiz.thresholds[y].readout;
          $log.debug('vm.readout: ', vm.readout);
          if (vm.quiz.thresholds[y].imagePath) {
            vm.readoutImage = vm.quiz.thresholds[y].imagePath;
            vm.readoutImageAlt = vm.quiz.thresholds[y].imageAltText;
          } else {
            vm.readoutImage = null;
            vm.readoutImageAlt = null;
          }
          vm.userPreference = vm.quiz.thresholds[y].userPreference;
          break;
        }
      }
    }
  }

  function getAnswerScore(question, idx, isWeightedScore) {
    var weightedScore = 'choice_' + idx + '_weightedScore';

    if (isWeightedScore && question.properties.hasOwnProperty(weightedScore) && !isNaN(question.properties[weightedScore])) {
      return _.toNumber(question.properties[weightedScore]);
    }
    //if weighted score property does not exist, than the default value of a correct answer is 1
    return 1;
  }

  /**
   * Get the score for a checkbox question
   *
   * @param {*} question the question widget
   * @param {Boolean} isWeightedScore indicates scoring is weighted
   */
  function getCheckboxAnswerScore(question, isWeightedScore) {
    if (!question.response) {
      //should never happen, "Complete" button should not be enabled unless at least 1 item is checked
      return 0;
    }

    var responses = question.response.split(',');
    var answerCount = question.properties.answerCount;
    var allowSingleCorrectAnswer = question.properties && (question.properties.allowSingleCorrectAnswer === 'true' || question.properties.allowSingleCorrectAnswer === true);

    var score = 0;
    var missingCorrectAnswer = false;
    var hasACorrectAnswer = false;
    for (var i = 0; i < answerCount; i++) {
      var choiceIndexIsCorrect = question.properties['choice_' + i + '_isCorrect'] === 'true' || question.properties['choice_' + i + '_isCorrect'] === true;
      if (choiceIndexIsCorrect) {
        if (_.includes(responses, i.toString())) {
          score += getAnswerScore(question, i, isWeightedScore);
          hasACorrectAnswer = true;
        } else if (!allowSingleCorrectAnswer) {
          //correct answer was not selected
          missingCorrectAnswer = true;
        }
      }
    }

    if (!isWeightedScore && hasACorrectAnswer) {
      // Alter score for scoring type sum
      score = 1;
    }
    return missingCorrectAnswer ? 0 : score;
  }

  /** Get score for a question that has a single correct answer **/
  function getSingleAnswerScore(question, isWeightedScore) {
    var idx = question.response;
    var isCorrect = 'choice_' + idx + '_isCorrect';

    if (question.properties.hasOwnProperty(isCorrect) && question.properties[isCorrect] === 'true') {
      return getAnswerScore(question, idx, isWeightedScore);
    }

    return 0;
  }

  function hasQuestionReadout(question) {
    //if 1 answer has a readout, they all do. only need to check the first one
    var readout = 'choice_0_readout';
    return question.properties.hasOwnProperty(readout) && !_.isEmpty(question.properties[readout]);
  }
})();